import type {PermissionsRecordType} from '../permissions';

export const telephonyPermissions = {
  telephonySettingsRead: {
    actionId: 'READ',
    resourceId: 'TELEPHONY_SETTINGS',
    scopes: [],
  },
  telephonySettingsWrite: {
    actionId: 'WRITE',
    resourceId: 'TELEPHONY_SETTINGS',
    scopes: [],
  },
  telephonyCallStart: {
    actionId: 'START',
    resourceId: 'TELEPHONY_CALL',
    scopes: [],
  },
} satisfies PermissionsRecordType;
